<template>
	<div class="qw-image-uploader-uploading-view el-upload-list el-upload-list--picture-card">
		<div class="el-upload-list__item" :class="{'circle-border-radius': isCircleComputed}">
			<el-progress
				type="circle"
				:percentage="uploadProgress"/>
		</div>
	</div>
</template>

<script>
export default {
	name: "QwImageUploaderUploadingView",

	props: {
		isCircleComputed: Boolean,
		uploadProgress: Number,
	},
}
</script>
